module.exports = __webpack_public_path__ + "img/2.457a95f0.jpg";